document.addEventListener('alpine:init', () => {
  Alpine.data('upsellPdpCart', (showQuantity, showProductType) => ({
    showQuantity,
    showProductType,

    init() {
      // nothing to fetch, cart is already reactive
    },

    get cart() {
      return Alpine.store('cart');
    },

    get cartItems() {
      return this.cart?.state?.items || [];
    },

    hasUpsellItem() {
      return this.cartItems.some(
        item => item?.properties?._upsell === 'PDP Upsell'
      );
    }
  }));
});
